import styled from 'styled-components';

const SubHeadingStyles = styled.section`
  background: ${props => props.background || 'rgba(0, 0, 0, .05)'};
  color: ${props =>
    props.appearance
      ? props.appearance === 'light'
        ? props.theme.colors.white
        : props.theme.colors.darkBlue
      : props.theme.colors.darkBlue};
  overflow: visible !important;
  position: relative;
  padding: 1.19rem ${props => props.theme.padding.inner};

  .inner {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: auto;
    max-width: ${props => props.theme.maxWidths.containerSmall};

    @media (min-width: ${props => props.theme.breakpoints.tablet}) {
      max-width: ${props => props.theme.maxWidths.content};
      flex-direction: row;
    }

    @media (prefers-reduced-motion: no-preference) {
      .isAnimated& {
        opacity: 0;
        transform: translateY(10px);
        transition: all 0.4s ease-in-out;
      }
    }

    .active& {
      opacity: 1;
      transform: none;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      padding: 0 10px;
      margin: 0;
      color: inherit;

      sup {
        font-size: 0.5em;
      }
    }

    h2 {
      font-family: ${props => props.theme.fonts.primary};
      font-size: ${props => props.theme.type.h5};
      font-weight: 600;
      line-height: ${props => props.theme.lineHeights.h5};
      letter-spacing: ${props => props.theme.letterSpacing.h5};
    }

    * {
      color: ${props =>
        props.appearance === 'light' ? 'inherit' : props.theme.colors.grey1};

      @media (min-width: ${props => props.theme.breakpoints.tablet}) {
        margin-top: 0;
        margin-bottom: 0;
      }
      @media (max-width: ${props => props.theme.breakpoints.tablet}) {
        &:first-child {
          margin-top: 0;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    a {
      font-size: 14px;
      margin-right: initial;
      padding-left: 10px;
      padding-top: 4px;
      width: max-content;
      text-decoration: none;
      padding-right: 1.5rem;
      position: relative;
      vertical-align: middle;

      svg {
        height: 1em;
        margin-top: -0.1em;
        margin-left: 0;
        transition: 0.3s ease-in-out;
        position: absolute;
        bottom: 1.6px;
        right: 0px;
      }
      :hover {
        svg {
          transform: translateX(38%);
        }
      }
    }
  }
`;

export default SubHeadingStyles;
